// extracted by mini-css-extract-plugin
module.exports = {"cohort-list":"CohortList_cohort-list__14CQP","cohort-members":"CohortList_cohort-members__1TFIe","cohort":"CohortList_cohort__3e6u6","cohort-name":"CohortList_cohort-name__3DORO"};